import { render, staticRenderFns } from "./n-info-tooltip.vue?vue&type=template&id=654f3e7f&lang=pug&"
import script from "./n-info-tooltip.vue?vue&type=script&lang=js&"
export * from "./n-info-tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports